import { Theme } from '../../theme';

export const formVariants = {
  field: {
    variant: 'text.body2',
    display: 'inline-block',
    background: 'field',
    width: 'fit-content',
    px: 3,
    py: 0, // adding padding is clipping the text?
    height: '30px',
    color: 'onField',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'fieldBorder',
    borderRadius: 'circle',
    ':hover': {
      borderColor: 'black',
    },
    // Focus Styles
    ':focus': {
      borderColor: 'primary',
      outline: 'none',
      boxShadow: (t: Theme) => `0 0 0 1px ${t.colors.primary}`,
      zIndex: '999998',
      '& + svg': {
        zIndex: '999999',
      },
    },
    '::placeholder': {
      // fontWeight: 'normal',
      opacity: 0.7,
    },
    '&[type=file]': {
      border: 'none',
      width: 'auto',
      ':focus': {
        border: 'none',
        boxShadow: 'none',
      },
      padding: 0,
      borderRadius: 0,
    },
    ':invalid': {
      borderColor: 'statusError',
      ':focus': {
        borderColor: 'statusError',
      },
    },
  },
  textarea: {
    variant: 'forms.field',
    minWidth: '96px',
    width: '100%',
    borderRadius: 'default',
    py: 2,
    ':invalid': {
      borderColor: 'statusError',
      ':focus': {
        borderColor: 'statusError',
      },
    },
  },
  accordion: {
    variant: 'forms.field',
    // height: 'auto',
    // lineHeight: '2',
    width: '80px',
    marginY: -1,
  },
  input: {
    variant: 'forms.field',
    minWidth: '96px',
    borderRadius: 'circle',
  },
  inputRoundedLeft: {
    variant: 'forms.field',
    minWidth: '96px',
    borderRadius: 'none',
    borderTopLeftRadius: 'circle',
    borderBottomLeftRadius: 'circle',
  },
  inputRoundedRight: {
    variant: 'forms.field',
    minWidth: '96px',
    borderRadius: 'none',
    borderTopRightRadius: 'circle',
    borderBottomRightRadius: 'circle',
  },
  inputSquare: {
    variant: 'forms.field',
    minWidth: '96px',
    borderRadius: 'none',
  },
  select: {
    variant: 'forms.field',
    pr: '20px',
    '& + svg': {
      fill: 'onField',
      size: '24px',
      ml: '-24px',
      transform: 'translate(-4px)',
    },
  },
  selectCombo: {
    variant: 'forms.select',
    borderRadius: 'none',
    borderTopLeftRadius: 'circle',
    borderBottomLeftRadius: 'circle',
  },
  checkbox: {
    color: 'primary',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  label: {
    variant: 'text.body2',
    color: 'onField',
    lineHeight: '24px', //
    fontWeight: 'bold',
    // '&:hover': {
    //   cursor: 'pointer',
    // },
  },
};
